import { defineStore } from 'pinia';
import { AdvancedFilter, AdvancedSearchConfiguration, Pagination, Project } from '@/types';
import projectListService, { projectListAdvanceSearch, projectListAdvanceSearchDOMFilter } from '@/services/api/projectsList';
import { PROJECT_URL } from '@/services/api/projects';
import { PaginatedListHeader } from '@/services/Factory/PaginatedListHeadersFactory';
import advancedSearchService from '@/services/advancedSearch';

interface ProjectState {
	projects: Project[];
	projectUrl: string;
	totalCount: number;
	errorLoading: boolean;
	headers: PaginatedListHeader[];
	tableLoading: boolean;
	filters: string[] | null;
	filtersConfiguration: any;
	advancedSearchConfiguration: AdvancedSearchConfiguration;
	advancedSearch: projectListAdvanceSearch;
	dataTableOptions: any;
	filterBuffer: AdvancedFilter[];
	advancedSearchLoading: boolean;
}

/**
 * Ne stocke pas le champ de recherche pour éviter la redirection automatique lors de l'utilisation en non-accessmaster
 */
export const useProjectStore = defineStore('project', {
	state: (): ProjectState => ({
		projects: [],
		projectUrl: PROJECT_URL,
		totalCount: 0,
		errorLoading: false,
		headers: [],
		tableLoading: false,
		filters: [],
		filtersConfiguration: {},
		advancedSearchConfiguration: {
			filters: [],
			values: []
		},
		advancedSearch: { 'project-name': [] },
		dataTableOptions: {},
		filterBuffer: [],
		advancedSearchLoading: false
	}),
	persist: {
		storage: localStorage,
		paths: ['projects', 'totalCount', 'projectUrl', 'dataTableOptions']
	},
	actions: {
		async fetch( pagination: Pagination, advancedSearch?: projectListAdvanceSearch): Promise<void> {
			const response = await projectListService.getProjectsList(this.projectUrl, pagination,  advancedSearch);
			this.projects = response.data.items;
			this.totalCount = response.data.totalCount;
		},
		async updateFilters(filters: projectListAdvanceSearchDOMFilter[]): Promise<void> {
			this.advancedSearch = { 'project-name': [] };
			filters.forEach((filter ) => {
				if ('project-name' ===  filter.name) {
					if ( projectListService.isNumberArray(filter.value)) {
						this.advancedSearch['project-name'] = filter.value;
					}
				}
			});
		},

		async setBuffer(filters: any): Promise<void> {
			this.filterBuffer = filters;
		},
		async loadAdvancedSearch() {
			this.advancedSearchLoading = true;
			const response = await projectListService.getProjectsListAdvancedSearch(this.projectUrl);

			this.advancedSearchConfiguration.filters = response.data.advancedSearch.filters;

			if (this.filterBuffer !== this.advancedSearchConfiguration.filters && this.filterBuffer.length > 0 ) {
				this.advancedSearchConfiguration.filters = this.filterBuffer;
			}

			advancedSearchService.formatChip(this.advancedSearchConfiguration);
			this.advancedSearchLoading = false;
		}
	}
});
